import { clsx } from "clsx";
import { Calendar } from "primereact/calendar";
import React, { useEffect, useRef, useState } from "react";
import { DateRangePicker } from "react-date-range";
import SelectorSkeleton from "../SelectorSkeleton";
import classes from "./DatePicker.module.css";
import { CalendarIcon } from "../../constant";
const formatDate = (date) => {
  if (!date) return "";
  return date
    ?.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    })
    .replace(",", "");
};
const DatePicker = ({ value, type = "", onChange }) => {
  const menu = useRef(null);
  const debounceRef = useRef(null);

  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  const handleDateSelect = (e) => {
    onChange(e.value);
    menu.current.hide(); // Hide the menu after selecting a date
  };

  const derivedValue = () => {
    let computedValue = "Select Date";

    if (Array.isArray(value)) {
      computedValue = `${formatDate(value[0].startDate)} - ${formatDate(
        value[0].endDate,
      )}`;
    } else if (value) {
      computedValue = value;
    }
    return computedValue;
  };

  const calendarType = () => {
    if (type === "range") {
      return (
        <div
          className={clsx(
            "absolute z-50 mt-2 calendar-wrapper",
            classes.calendarWrapper,
          )}
          onClick={(e) => e.stopPropagation()}
        >
          <DateRangePicker
            onChange={(item) => {
              const selection = item.selection;

              // ✅ Update UI immediately
              setLocalValue([selection]);

              // ⏳ Debounce parent update
              if (debounceRef.current) {
                clearTimeout(debounceRef.current);
              }

              debounceRef.current = setTimeout(() => {
                onChange([selection]);
              }, 500);
            }}
            placeholder="Select Date"
            moveRangeOnFirstSelection={false}
            ranges={localValue}
            months={2}
            direction="horizontal"
            rangeColors={["var(--primary-color)"]}
            showMonthAndYearPickers={true}
            showDateDisplay={false}
          />
        </div>
      );
    }

    return (
      <Calendar
        inline
        value={value}
        onChange={handleDateSelect}
        showWeek={false}
      />
    );
  };

  return (
    <>
      <SelectorSkeleton
        icon={<CalendarIcon />}
        options={[
          {
            label: "Select Date",
            template: calendarType(),
          },
        ]}
        value={derivedValue()}
      />
    </>
  );
};

export default DatePicker;
